import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  area: {
    backgroundColor: "#ffffff",
    paddingHorizontal: "20",
    paddingVertical: "32",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: "12",
    marginBottom: 24,
  },
  number: {
    fontFamily: "SourceSerifPro",
    color: "#000000",
    fontWeight: 400,
    fontSize: "32",
    lineHeight: 1.125,
  },
  status: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: 1.5,
    color: "#434992",
  },
  sides: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "stretch",
    marginBottom: 24,
  },
  side: {
    flexBasis: "50%",
    padding: "0 12px",
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
  },
  sideBlock: {
    border: "1px solid #C1CFD4",
    width: "100%",
    flexBasis: "100%",
    borderRadius: 8,
    padding: 12,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    rowGap: 32,
    alignItems: "flex-start",
  },
  sideHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 16,
    width: "100%",
  },
  caption: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 10,
    lineHeight: 1.42,
    letterSpacing: 1,
    textTransform: "uppercase",
    color: "#666A84",
    marginBottom: 4,
  },
  text: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: 1.5,
    color: "#1A2147",
  },
  avatarName: {
    maxWidth: "80%",
  },
  avatarFrom: {
    width: 32,
    height: 32,
    flexBasis: 32,
    backgroundColor: "#F4F1FE",
    color: "#8F6FF6",
    border: "1px solid #8F6FF6",
    borderRadius: 100,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  avatarTo: {
    width: 32,
    height: 32,
    flexBasis: 32,
    backgroundColor: "#EDF7F3",
    color: "#489D78",
    border: "1px solid #489D78",
    borderRadius: 100,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  avatarChar: {
    fontFamily: "SourceSerifPro",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 18,
    lineHeight: 1.2,
    textTransform: "uppercase",
  },
  contacts: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: 1.5,
    color: "#666A84",
  },
  dates: {
    padding: "0 24px",
    display: "flex",
    flexDirection: "row",
    columnGap: 32,
  },
  table: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    paddingHorizontal: "12",
  },
  thead: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
    paddingVertical: "16",
  },
  tbody: {
    width: "100%",
    rowGap: 24,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    paddingTop: "16",
    borderTop: "1px solid #E8E9ED",
  },
  summaryRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    paddingTop: "16",
    borderTop: "1px solid #E8E9ED",
  },
  summaryCell: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: 8,
    flexBasis: "25%",
  },
  summaryCellLabel: {
    color: "#0e1227",
    fontWeight: 600,
    fontSize: 12,
  },
  summaryCellValue: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    flexGrow: 1,
  },
  summaryCellValueInteger: {
    fontFamily: "SourceSerifPro",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 20,
    color: "#0b0e1e",
  },
  summaryCellValueDecimal: {
    fontFamily: "SourceSerifPro",
    fontWeight: 400,
    fontSize: 16,
    color: "#0b0e1e",
  },
  summaryCellHint: {
    fontFamily: "Manrope",
    fontSize: 10,
    color: "#666a84",
    fontWeight: 600,
  },
  textDesc: {
    flex: 1,
    flexGrow: 1,
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: 1.5,
    color: "#1A2147",
  },
  textRate: {
    flex: 1,
    flexShrink: 0,
    flexBasis: "120px",
    maxWidth: "120px",
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: 1.5,
    color: "#1A2147",
    paddingLeft: 12,
    textAlign: "right",
  },
  sum: {
    fontFamily: "SourceSerifPro",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 32,
    lineHeight: 1.125,
    color: "#1A2147",
  },
  note: {
    marginTop: "24",
    padding: "0 12px",
  },
  details: {
    marginTop: 12,
    backgroundColor: "#EDF7F3",
    border: "1px solid #AED9C6",
    borderRadius: 10,
    marginHorizontal: 12,
    padding: 12,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 16,
  },
  detailsHeading: {
    display: "flex",
    flexDirection: "row",
    gap: 8,
    alignItems: "center",
  },
  detailsTitle: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 10,
    lineHeight: 1.5,
    color: "#1A2147",
    letterSpacing: 1,
    textTransform: "uppercase",
    width: "150px",
  },
  detailsSubtitleContainer: {
    width: "100%",
  },
  detailsSubtitle: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 10,
    lineHeight: 1.5,
    color: "#666A84",
  },
  detailsDataContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  detailsData: {
    flexBasis: "66.666667%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: 4,
    width: "100%",
  },
  detailsLine: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
  },
  detailsCaption: {
    flexBasis: "50%",
    textTransform: "uppercase",
    color: "#666A84",
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 10,
    lineHeight: 1.5,
    letterSpacing: 1,
    width: "150px",
  },
  detailsTextContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: 4,
    padding: 0,
    margin: 0,
  },
  detailsText: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: 1.5,
    color: "#1A2147",
    width: "350px",
  },
  detailsTextHidden: {
    width: "200px",
    height: "16px",
    display: "flex",
    padding: 0,
    margin: 0,
    backgroundColor: "#C8E6D9",
    borderRadius: 16,
  },
  footer: {
    marginTop: 12,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  textBold: {
    fontWeight: 800,
  },
  textRed: {
    color: "#dc2626",
  },
});
